import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from './ui/button';

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();

  const toggleLanguage = () => {
    const newLang = i18n.language === 'lt' ? 'en' : 'lt';
    i18n.changeLanguage(newLang);
  };

  return (
    <Button 
      variant="outline" 
      size="sm" 
      onClick={toggleLanguage}
      className="border-emerald-200 text-emerald-700 hover:bg-emerald-50 bg-white shadow-sm"
      style={{
        position: 'fixed',
        top: '1rem',
        right: '1rem',
        zIndex: 9999,
        minWidth: '3rem',
        fontSize: '0.875rem',
        fontWeight: '600',
        padding: '0.5rem 0.75rem'
      }}
    >
      {i18n.language === 'lt' ? 'EN' : 'LT'}
    </Button>
  );
} 